export enum ApiType {
    Application = 'application',
    Authorization = 'authorization',
    Download = 'download'
}
